export default __webpack_public_path__ + "static/media/edX.4df87d51.png";